var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 23.4805C16.0215 23.4805 16.4961 22.9268 16.8213 22.083L22.6221 6.91309C22.7715 6.51758 22.8594 6.1748 22.8594 5.87598C22.8594 5.25195 22.4639 4.85645 21.8311 4.85645C21.541 4.85645 21.1895 4.93555 20.8027 5.08496L5.5625 10.9209C4.80664 11.2109 4.23535 11.6855 4.23535 12.3711C4.23535 13.2148 4.85938 13.5312 5.7207 13.7861L12.0664 15.6494L13.9121 21.9248C14.1758 22.8213 14.4922 23.4805 15.3359 23.4805ZM12.5762 14.0322L7.11816 12.3623C6.98633 12.3271 6.95117 12.2832 6.95117 12.2305C6.95117 12.1689 6.98633 12.1162 7.10059 12.0811L17.5332 8.09082C18.2803 7.80078 19.0098 7.44922 19.8096 7.08008C19.1768 7.58984 18.4033 8.21387 17.876 8.74121L12.5762 14.0322ZM15.4941 20.7734C15.4326 20.7734 15.3887 20.7207 15.3535 20.5977L13.6836 15.1396L18.9746 9.83984C19.4844 9.32129 20.1348 8.52148 20.6445 7.87988C20.2754 8.68848 19.915 9.42676 19.625 10.1826L15.6348 20.6152C15.5908 20.7295 15.5557 20.7734 15.4941 20.7734Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4fe7158a3c1edb285eb83d7b38b8f9d0.svg";
export { ForwardRef as ReactComponent };